import { connect } from 'react-redux';
import AdminKioskVerifyForm from './AdminKioskVerifyForm';

const mapStateToProps = (state) => {
  const auth =
    state.get('auth') && state.get('auth').toJS && state.get('auth').toJS();
  const kiosk = state.get('kiosk');
  return {
    ...auth,
    ...kiosk
  };
};

const AdminKioskVerifyFormContainer =
  connect(mapStateToProps)(AdminKioskVerifyForm);

export default AdminKioskVerifyFormContainer;
